// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider___pf\\+ZK{margin:var(--made-space-6-x) 0}.importInstructions___W\\+\\+fO{font-size:var(--made-font-size-04);line-height:var(--made-line-height-1-5-x)}\n", "",{"version":3,"sources":["webpack://./src/components/ImportEntries/ImportInstructions/ImportInstructions.css"],"names":[],"mappings":"AAAA,kBACI,8BAAA,CAGJ,8BACI,kCAAA,CACA,yCAAA","sourcesContent":[".divider {\n    margin: var(--made-space-6-x) 0;\n}\n\n.importInstructions {\n    font-size: var(--made-font-size-04);\n    line-height: var(--made-line-height-1-5-x);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": "divider___pf+ZK",
	"importInstructions": "importInstructions___W++fO"
};
export default ___CSS_LOADER_EXPORT___;
